import './style/scss/style.scss';
//@ts-expect-error
import Theme from 'CALO_THEME'; // defined in gulp/loader.js
import ScormAPI from './scorm/scorm-api';

const locales: Record<CaloLanguage, Record<string, string>> = {
  ar: {
    loading: 'Loading...',
    message:
      'For enhanced experience, please disable pop-up block on your browser',
    button: 'click here to launch the application',
    '000300': 'Licence valid',
    '000303': 'Licence renewed',
    '020300': 'Licence activated',
    '020301': 'Licence not yet activated',
    '020311': 'license-not-found',
    '000301': 'Licence activated',
    '020302': 'Impossible to activate licence',
    '020303': 'Activation code not yet active',
    '020304': 'Activation code expired',
    '020305': 'Number of available licences exeeded',
    '020306': 'Licence server error',
    '020307': 'Temporary licence already used',
    '020309': 'Problem internal to licence server',
    '020308': 'server-warning-getvar',
    '020310': 'server-warning-operationabuse',
  },
  en: {
    loading: 'Loading...',
    message:
      'For enhanced experience, please disable pop-up block on your browser',
    button: 'click here to launch the application',
    '000300': 'Licence valid',
    '000303': 'Licence renewed',
    '020300': 'Licence activated',
    '020301': 'Licence not yet activated',
    '020311': 'license-not-found',
    '000301': 'Licence activated',
    '020302': 'Impossible to activate licence',
    '020303': 'Activation code not yet active',
    '020304': 'Activation code expired',
    '020305': 'Number of available licences exeeded',
    '020306': 'Licence server error',
    '020307': 'Temporary licence already used',
    '020309': 'Problem internal to licence server',
    '020308': 'server-warning-getvar',
    '020310': 'server-warning-operationabuse',
  },
  es: {
    loading: 'Loading...',
    message:
      'Para mejorar la visualización se recomienda desactivar el bloqueo de ventanas emergentes en el navegador.',
    button: 'Haga click aquí para lanzar la aplicación.',
    '000300': 'Licencia válida',
    '000303': 'Licencia renovada',
    '020300': 'Licencia activada',
    '020301': 'Licencia aún no activada ',
    '020311': 'Licencia no encontrada ',
    '000301': 'Licencia activada',
    '020302': 'Imposible activar la licencia',
    '020303': 'El código de activación no está activo. ',
    '020304': 'El código de activación caducó.',
    '020305': 'El número de licencias disponibles ha excedido.',
    '020306': 'Error con el servidor de las licencias',
    '020307': 'Licencia provisional utilizada',
    '020309': 'Problema con el servidor de las licencias',
    '020308': 'server-warning-getvar',
    '020310': 'server-warning-operationabuse',
  },
  fr: {
    loading: 'Loading...',
    message:
      "Pour améliorer l'affichage, désactiver le blocage des fenêtres pop-up sur votre navigateur",
    button: "Cliquer ici pour lancer l'application",
    '000300': 'Licence en cours de validité',
    '000303': 'Licence renouvelée',
    '020300': 'La licence a expiré.',
    '020301': "La licence n'est pas encore activée.",
    '020311': "La licence n'a pas été trouvée.",
    '000301': 'Licence activée',
    '020302': 'actcode-ko',
    '020303': "Le code d'activation n'est pas encore actif.",
    '020304': "Le code d'activation a expiré.",
    '020305': 'Nombre de licences disponibles dépassé',
    '020306': 'Erreur du serveur de licences',
    '020307': 'Licence provisoire déjà utilisée',
    '020309': 'Problème interne du serveur des licences',
    '020308': 'server-warning-getvar',
    '020310': 'server-warning-operationabuse',
  },
  it: {
    loading: 'Caricamento...',
    message:
      "Per un'esperienza migliore, per favore disabilita il blocco pop-up del browser",
    button: "clicca qui per avviare l'applicazione",
    '000300': 'Licenza valida',
    '000303': 'Licenza rinnovata',
    '020300': 'Licenza scaduta',
    '020301': 'Licenza non ancora attiva',
    '020311': 'Licenza non trovata',
    '000301': 'Licenza attivata',
    '020302': 'Impossibile attivare la licenza',
    '020303': 'Codice di attivazione non ancora attivo',
    '020304': 'Codice di attivazione scaduto',
    '020305': 'Numero di licenze disponibili superato"',
    '020306': 'Errore del license server',
    '020307': 'Licenza provvisoria già utilizzata',
    '020309': 'Problema interno del licenser server',
    '020308': 'server-warning-getvar',
    '020310': 'server-warning-operationabuse',
  },
  de: {
    loading: 'Loading...',
    message:
      'Für bessere Leistungen, deaktivieren Sie bitte den Pop-up-Blocker Ihres Browsers',
    button: 'Klicken Sie hier, um die Anwendung zu starten',
    '000300': 'Lizenz gültig',
    '000303': 'Lizenz erneuert',
    '020300': 'Lizenz abgelaufen',
    '020301': 'Lizenz noch nicht aktiviert',
    '020311': 'Lizenz nicht gefunden',
    '000301': 'Lizenz aktiviert',
    '020302': 'Lizenz nicht aktivierbar',
    '020303': 'Aktivierungscode noch nicht aktiv',
    '020304': 'Aktivierungscode abgelaufen',
    '020305': 'Anzahl der verfügbaren Lizenzen überschritten',
    '020306': 'Lizenzserverfehler',
    '020307': 'Temporäre Lizenz bereits benutzt',
    '020309': 'Internes Lizenzserverproblem',
    '020308': 'server-warning-getvar',
    '020310': 'server-warning-operationabuse',
  },
};

function t(lang: CaloLanguage, id: string) {
  return (locales[lang] || locales.en)[id];
}

const runCaLo = () => {
  const iframe = document.createElement('iframe');
  iframe.src = 'calo.html';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.position = 'fixed';
  iframe.style.top = '0';
  iframe.style.left = '0';
  iframe.style.border = 'none';

  document.querySelector('#root')?.append(iframe);
};

const scormock = require('./lib/scormock').default;
// __CALOID is a global var deined in the CaLo launcher
// * frenb1pr001 : contains Drag and Drop Columns
// * itena1re001 : contains PIO vertical + Rollover
// * itfra2wr002 : contains PIO horizontal
// * enenb2gr001 : contains Drag and Drop QandA
// * itfra1pr004 : Hot Spot Ordered
// * frena2gr006 : Hot Spot Unorderd
// * itenb1pr001 : Player Audio Image (with assets)
// * ittest001 : custom unit with excercises
const caloId = process.env.CALOID || 'frenb1pr001';

//@ts-expect-error
window.API = new scormock({
  'cmi.launch_data': `ACTIVATIONCODE_@_${caloId}_@_01_@_multi-best_@_normal`,
  'cmi.core.student_name': 'studentName',
  'cmi.core.student_id': 'studentId',
});

const ServerAPI = new ScormAPI();
ServerAPI.do('initialize');

//@ts-expect-error
window.CALO_SERVER_API = ServerAPI;
//@ts-expect-error
window.CALO_SERVER = './contents';
//@ts-expect-error
window.CALO_CDN = '';
//@ts-expect-error
window.CALO_BOOTSTRAP_CONTAINER = document.querySelector('#root');
//@ts-expect-error
window.__CALOID = caloId;
//@ts-expect-error
window.LANG = window.__CALOID.substr(0, 2);
//@ts-expect-error
window.SCORM_USER = {
  activationCode: 'activationCode',
  pubKey: '',
  token: '',
  // backend send this value in seconds
  expDate: '',
};

(function init() {
  document.querySelector('#full-logo')?.setAttribute('src', Theme.logo.full);
  //@ts-expect-error
  document.querySelector('#message')!.textContent = t(window.LANG, 'loading');
  runCaLo();
})();
